import { Box, Checkbox, Stack, StackProps, Typography } from '@mui/material';
import { ChangeEvent, memo, useId, useMemo } from 'react';

type Props = {
  checkboxDisabled?: boolean;
  isHovered?: boolean;
  isSelected?: boolean;
  label: string;
  onLabelClick?: () => void;
  onCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  primaryValue: number | undefined;
  secondaryValue: number | undefined;
  unit: string;
  StackProps?: StackProps;
};

export const RowListItem = memo(
  ({
    isHovered,
    isSelected,
    checkboxDisabled,
    onCheckboxChange,
    onLabelClick,
    StackProps,
    label,
    primaryValue,
    secondaryValue,
    unit,
  }: Props) => {
    const backgroundColor = useMemo(() => {
      if (isHovered) return '#D3D9E0';
      if (isSelected) return '#f6f8fb';
      return 'white';
    }, [isHovered, isSelected]);

    const id = useId();

    return (
      <Stack
        direction={'row'}
        alignItems={'center'}
        width={'100%'}
        sx={{ cursor: 'pointer', backgroundColor }}
        height={'100%'}
        {...StackProps}
      >
        {isSelected && <Box height={'100%'} width={'7px'} sx={{ backgroundColor: '#35c2a3' }} />}
        <Box display={'flex'} alignItems={'center'}>
          <Checkbox
            id={id}
            name="custom-block-checkbox"
            disabled={checkboxDisabled}
            checked={isSelected}
            onChange={onCheckboxChange}
            sx={{ ml: isSelected ? 0 : 1 }}
          />
          <Typography fontSize={'14px'} color="primary.main" onClick={onLabelClick}>
            {label}
          </Typography>
        </Box>
        <Stack
          direction={'row'}
          alignItems={'center'}
          gap={'3px'}
          ml={'auto'}
          mr={2}
          sx={{ color: 'primary.main', fontWeight: 500, fontSize: '12px' }}
        >
          <p>{primaryValue?.toFixed(2)}</p>
          <p>/</p>
          <p>
            {secondaryValue?.toFixed(2)} {unit}
          </p>
        </Stack>
      </Stack>
    );
  }
);
